// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5898ebb","373":"d6e46fbb","411":"c91f2abc","455":"535eb936","480":"04d82196","564":"f876f82c","606":"7e686fd7","655":"388177b7","744":"b483674f","801":"13ca8545","809":"b8953c88","977":"51f55cf2"}[chunkId] + ".chunk.js";
};